import accounting from 'accounting'
let config = require('config');

export function formatMoney(amount, currency) {
  let currency_format = config.default.currency_format;
  currency_format.symbol = currency;
  
  let formattedPositive = accounting.formatMoney(Math.abs(amount), config.default.currency_format);
  let formattedNegative = `(${accounting.formatMoney(Math.abs(amount))}) ${config.default.currency_format.symbol}`;
  return amount < 0 ? formattedNegative : formattedPositive;
}



// WEBPACK FOOTER //
// ./src/helpers/formatMoney.js